import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Spinner } from '../ui/Spinner';

/**
 * Allows access to /profissional/* for:
 *   - admin (role = 'admin')
 *   - astrologer_pro users whose astrologer profile is active
 *
 * Client-side only, every edge function enforces server-side permissions.
 */
export function ProfessionalGuard() {
  const { profile, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--bg-base)' }}>
        <Spinner size="lg" />
      </div>
    );
  }

  if (!profile) return <Navigate to="/login" replace />;

  const isAdmin      = profile.role === 'admin';
  const isAstrologer = profile.subscription_tier === 'astrologer_pro';

  if (!isAdmin && !isAstrologer) {
    return <Navigate to="/pricing" replace />;
  }

  return <Outlet />;
}
